import { Col, Container, Row } from 'react-bootstrap'
import MainLayout from '../components/MainLayout'
import OverviewBar from '../components/OverviewBar'
import { C98SolendPool } from '../components/pools/C98SolendPool'
import HedgeStakingPool from '../components/pools/HedgeStakingPool'
import LiquidationPool from '../components/pools/LiquidationPool'
import { OrcaHdgPool } from '../components/pools/OrcaHdgPool'
import { OrcaUshPool } from '../components/pools/OrcaUshPool'
import { OrcaUshUsdtPool } from '../components/pools/OrcaUshUsdtPool'
import { RaydiumHdgPool } from '../components/pools/RaydiumHdgPool'
import { SaberUshPool } from '../components/pools/SaberUshPool'
import { PortUshPool } from '../components/pools/PortUshPool'
import { AtrixUshPool } from '../components/pools/AtrixUshPool'
import { SolendStablePool } from '../components/pools/SolendStablePool'
import { SolendNazarePool } from '../components/pools/SolendNazarePool'

export default function Pools() {
  return (
    <>
      <MainLayout>
        <OverviewBar />
        <Container>
          <Row>
            <Col>
              <h2>Pools</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={{ span: 6 }}>
              <LiquidationPool />
            </Col>
            <Col lg={{ span: 6 }}>
              <HedgeStakingPool />
            </Col>
          </Row>
          {/* <Row className="mt-4 mb-2">
            <Col>
              <h2>Other Pools</h2>
            </Col>
          </Row>
          <Row className="px-4 text-center mb-2 d-none d-lg-flex">
            <Col>Provider</Col>
            <Col>Asset</Col>
            <Col>APR</Col>
            <Col className='text-end'><span className='me-5'>TVL</span></Col>
            <Col>Audit</Col>
            <Col></Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <OrcaUshPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <OrcaUshUsdtPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <OrcaHdgPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <AtrixUshPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <SaberUshPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <RaydiumHdgPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <SolendNazarePool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <SolendStablePool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <C98SolendPool />
            </Col>
          </Row>
          <Row>
            <Col className="mb-2">
              <PortUshPool />
            </Col>
          </Row> */}
        </Container>
      </MainLayout>
    </>
  )
}
